const socialMediaData = [
  {
    title: "facebook",
    name: "@nathanf",
    totalFollowers: 1987,
    followCurrent: 12,
    followLast: 11,
    viewsCurrent: 87,
    viewsLast: 84,
    likesCurrent: 52,
    likesLast: 53,
  },
  {
    title: "twitter",
    name: "@nathanf",
    totalFollowers: 1044,
    followCurrent: 99,
    followLast: 90,
    viewsCurrent: 117,
    viewsLast: 29,
    likesCurrent: 507,
    likesLast: 77,
  },
  {
    title: "instagram",
    name: "@realnathanf",
    totalFollowers: 11734,
    followCurrent: 1099,
    followLast: 956,
    viewsCurrent: 52375,
    viewsLast: 3550,
    likesCurrent: 5462,
    likesLast: 232,
  },
  {
    title: "youtube",
    name: "Nathan F.",
    totalFollowers: 8239,
    followCurrent: 144,
    followLast: 169,
    viewsCurrent: 1407,
    viewsLast: 1590,
    likesCurrent: 107,
    likesLast: 132,
  },
];

export function getData() {
  return socialMediaData;
}
